// extracted by css-extract-rspack-plugin
export default {"box":"Field-module__box___XTtQA","field":"Field-module__field___YIi2P"};